import React from "react";
import Link from "gatsby-link";
import styled from "styled-components";
import colors from "../../styles/colors";

// The same styling as in the /grammatica/Wrapper/ component
const List = styled.ul`
  color: ${colors.main};
  font-size: 0.9em;
  font-weight: 400;
  letter-spacing: 0px;
  list-style: none;
  margin: 0;
  padding: 0 !important;
  text-transform: none;

  & + h2 {
    margin-top: 2em;
  }

  > li {
    line-height: 1.3em;
    margin-top: 0.55em;
    padding-left: 0px !important;
  }
`;

const Container = styled.div`
  margin-bottom: 2em;
`;

export default ({ book, chapter }) => {
  const latinNoGrammar = [13, 19, 20, 27, 34, 41, 47, 48, 53, 55];
  const greekNoGrammar = [];

  const grammarlessChapters = book == "spqr" ? latinNoGrammar : greekNoGrammar;

  return (
    <Container id="vooraf" class="noprint">
      <h2>Voordat ik begin</h2>
      <List>
        {grammarlessChapters.includes(chapter) ? null : (
          <li>
            <Link to={`../${chapter}._grammatica`}>
              Heb ik alle leerdoelen voor dit hoofdstuk behaald?
            </Link>
          </li>
        )}

        <li>
          <a
            href={
              book == "spqr"
                ? "https://www.memrise.com/course/1616616/spqr/"
                : "https://www.memrise.com/course/1616658/argo/"
            }
          >
            Ken ik ten minste de eerste 10 woordjes van les {chapter}?
          </a>
        </li>
      </List>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/components/tekst/Vooraf.js